"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_1 = require("@material-ui/icons");
var achievements = {
    'cards-created': {
        icon: react_1.default.createElement(icons_1.AddBoxRounded, null),
        title: function (count) {
            return "Created " + (count === 1 ? 'a' : count) + " card" + (count !== 1 ? 's' : '');
        },
    },
    'cards-reviewed': {
        icon: react_1.default.createElement(icons_1.RefreshRounded, null),
        title: function (count) {
            return "Reviewed " + (count === 1 ? 'a' : count) + " card" + (count !== 1 ? 's' : '');
        },
    },
    'cards-mastered': {
        icon: react_1.default.createElement(icons_1.CheckBoxRounded, null),
        title: function (count) {
            return "Mastered " + (count === 1 ? 'a' : count) + " card" + (count !== 1 ? 's' : '');
        },
    },
    'decks-created': {
        icon: react_1.default.createElement(icons_1.LibraryAddRounded, null),
        title: function (count) {
            return "Created " + (count === 1 ? 'a' : count) + " deck" + (count !== 1 ? 's' : '');
        },
    },
    'study-plans-created': {
        icon: react_1.default.createElement(icons_1.EventNoteRounded, null),
        title: function (count) {
            return "Created " + (count === 1 ? 'a' : count) + " study plan" + (count !== 1 ? 's' : '');
        },
    },
    'items-completed': {
        icon: react_1.default.createElement(icons_1.EventAvailableRounded, null),
        title: function (count) {
            return "Completed " + (count === 1 ? 'a' : count) + " task" + (count !== 1 ? 's' : '');
        },
    },
    'timers-set': {
        icon: react_1.default.createElement(icons_1.AvTimerRounded, null),
        title: function (count) {
            return "Set " + (count === 1 ? 'a' : count) + " timer" + (count !== 1 ? 's' : '');
        },
    },
    'notes-created': {
        icon: react_1.default.createElement(icons_1.SubjectRounded, null),
        title: function (count) {
            return "Created " + (count === 1 ? 'a' : count) + " note" + (count !== 1 ? 's' : '');
        },
    },
    'analytics-viewed': {
        icon: react_1.default.createElement(icons_1.AssessmentRounded, null),
        title: function () { return "Viewed deck analytics"; },
    },
    'analytics-emails': {
        icon: react_1.default.createElement(icons_1.EmailRounded, null),
        title: function () { return "Signed up for daily session reports"; },
    },
    'deck-share-teachers': {
        icon: react_1.default.createElement(icons_1.ShareRounded, null),
        title: function () { return "Shared a deck with a teacher"; },
    },
    'deck-share-analytics': {
        icon: react_1.default.createElement(icons_1.ShareRounded, null),
        title: function () { return "Shared deck analytics"; },
    },
    'deck-share-collaborators': {
        icon: react_1.default.createElement(icons_1.ShareRounded, null),
        title: function (count) {
            return "Shared deck with " + (count === 1 ? 'a' : count) + " friend" + (count !== 1 ? 's' : '');
        },
    },
    'longest-streak': {
        icon: react_1.default.createElement(icons_1.WhatshotRounded, null),
        title: function (count) {
            return count === 1 ? 'Started a streak' : "Achieved a " + count + " day streak";
        },
    },
};
exports.default = achievements;
//# sourceMappingURL=achievements.js.map